import styles from './baseComponent.styles.scss'

export class BaseView {
  constructor($element) {
    Object.assign(this, { $element })
  }

  $postLink() {
    this.$element.addClass(styles.component)
  }
}

export class BaseCenteredView extends BaseView {
  $postLink() {
    super.$postLink()
    this.$element.addClass(styles.componentCentered)
  }
}

export class BaseFullView extends BaseView {
  $postLink() {
    super.$postLink()
    this.$element.addClass(styles.componentFull)
  }
}



// WEBPACK FOOTER //
// ./app/shared/utils/baseComponent.js